import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useInjectReducer } from 'redux-injectors';
import { authProfile } from 'redux/auth/selectors';
import { actions as profileActions } from 'redux/auth/slice';
import { notification } from 'antd';
import dayjs from 'dayjs';
import { useGlobalsQuery } from 'queries/useGlobalsQuery';
import { logout } from 'redux/logout';
import { name, actions, reducer } from './slice';
import { selectGlobals } from './selectors';

export default function useGlobals() {
  useInjectReducer({ key: name, reducer });
  const dispatch = useDispatch();
  const profile = useSelector(authProfile);
  const globals = useSelector(selectGlobals);

  const { data, isError } = useGlobalsQuery(profile?.countryID);

  useEffect(() => {
    if (!data || globals.loaded) return;

    dispatch(actions.success(data));

    const city = data.cities?.find((c) => c.id === profile?.cityID);
    const country = data.countries?.find((c) => c.id === profile?.countryID);
    const timeZone =
      city?.timeZone || country?.timeZone || 'America/Buenos_Aires';
    dayjs.tz.setDefault(timeZone);
    dispatch({ type: profileActions.setZoneinfo, payload: timeZone });
  }, [data, dispatch, globals.loaded, profile]);

  useEffect(() => {
    if (!isError) return;
    notification.error({
      message: 'Error iniciando la aplicacion',
      description:
        'Hubo un error llamando a los servicios, intente nuevamente o contacte a soporte.',
      duration: 20,
    });
    dispatch(logout());
    dispatch(actions.failure());
  }, [isError, dispatch]);

  return null;
}
